// 机构后台固定菜单配置 - 参考 orgPanel.html
export const orgMenuConfig = [
  {
    path: '/org/dashboard',
    name: 'OrgDashboard',
    titleKey: 'orgMenu.home',
    icon: 'HomeFilled',
    component: () => import('@/views/org/dashboard/index.vue')
  },
  {
    path: '/org/data-management',
    name: 'DataManagement',
    titleKey: 'orgMenu.dataManagement',
    icon: 'DataBoard',
    children: [
      {
        path: '/org/equipment',
        name: 'OrgEquipment',
        titleKey: 'orgMenu.equipment',
        icon: 'Connection',
        component: () => import('@/views/org/equipment/index.vue'),
        hidden: true
      },
      {
        path: '/org/equipment-foreign',
        name: 'OrgEquipmentForeign',
        titleKey: 'orgMenu.equipmentForeign',
        icon: 'Connection',
        component: () => import('@/views/org/equipment/foreign.vue')
      },
      {
        path: '/org/filter-record',
        name: 'OrgFilterRecord',
        titleKey: 'orgMenu.filterRecord',
        icon: 'Refresh',
        component: () => import('@/views/org/filterRecord/index.vue')
      },
      {
        path: '/org/water-card',
        name: 'OrgWaterCard',
        titleKey: 'orgMenu.waterCard',
        icon: 'CreditCard',
        component: () => import('@/views/org/waterCard/index.vue'),
        hidden: true
      }
    ]
  },
  {
    path: '/org/mqtt-query',
    name: 'MqttQuery',
    titleKey: 'orgMenu.mqttQuery',
    icon: 'Monitor',
    children: [
      {
        path: '/org/status',
        name: 'OrgStatus',
        titleKey: 'orgMenu.deviceStatus',
        icon: 'Monitor',
        component: () => import('@/views/org/status/index.vue')
      },
      {
        path: '/org/water-total',
        name: 'OrgWaterTotal',
        titleKey: 'orgMenu.waterTotal',
        icon: 'document',
        component: () => import('@/views/org/waterTotal/index.vue')
      },
      {
        path: '/org/water-record',
        name: 'OrgWaterRecord',
        titleKey: 'orgMenu.waterRecord',
        icon: 'Document',
        component: () => import('@/views/org/waterRecord/index.vue')
      }
    ]
  },
  {
    path: '/org/customer-management',
    name: 'OrgCustomerManagement',
    titleKey: 'orgMenu.customerManagement',
    icon: 'UserFilled',
    children: [
      {
        path: '/org/customer-admin',
        name: 'OrgCustomerAdmin',
        titleKey: 'orgMenu.customerList',
        icon: 'User',
        component: () => import('@/views/org/orgAdmin/index.vue'),
        hidden: true
      },
      {
        path: '/org/customer-foreign',
        name: 'OrgCustomerForeign',
        titleKey: 'orgMenu.customerForeign',
        icon: 'User',
        component: () => import('@/views/org/orgAdmin/foreign.vue')
      },
      {
        path: '/org/customer-data',
        name: 'OrgCustomerData',
        titleKey: 'orgMenu.customerData',
        icon: 'Document',
        component: () => import('@/views/org/customerData/index.vue'),
		hidden:true
      }
    ]
  }
]

// 机构后台路由配置 - 扁平化结构用于Vue Router
export const orgRoutes = [
  {
    path: '/org',
    component: () => import('@/layout/index.vue'),
    redirect: '/org/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'OrgDashboard',
        component: () => import('@/views/org/dashboard/index.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      },
      {
        path: 'equipment',
        name: 'OrgEquipment',
        component: () => import('@/views/org/equipment/index.vue'),
        meta: { title: '设备管理', icon: 'Connection' }
      },
      {
        path: 'equipment-foreign',
        name: 'OrgEquipmentForeign',
        component: () => import('@/views/org/equipment/foreign.vue'),
        meta: { title: '设备管理(国外)', icon: 'Connection' }
      },
      {
        path: 'filter-record',
        name: 'OrgFilterRecord',
        component: () => import('@/views/org/filterRecord/index.vue'),
        meta: { title: '换芯记录', icon: 'Refresh' }
      },
      {
        path: 'water-card',
        name: 'OrgWaterCard',
        component: () => import('@/views/org/waterCard/index.vue'),
        meta: { title: '水卡管理', icon: 'CreditCard' }
      },
      {
        path: 'status',
        name: 'OrgStatus',
        component: () => import('@/views/org/status/index.vue'),
        meta: { title: '设备状态查询', icon: 'Monitor' }
      },
      {
        path: 'water-total',
        name: 'OrgWaterTotal',
        component: () => import('@/views/org/waterTotal/index.vue'),
        meta: { title: '出水总量查询', icon: 'record' }
      },
      {
        path: 'water-record',
        name: 'OrgWaterRecord',
        component: () => import('@/views/org/waterRecord/index.vue'),
        meta: { title: '出水记录查询', icon: 'Document' }
      },
      {
        path: 'customer-admin',
        name: 'OrgCustomerAdmin',
        component: () => import('@/views/org/orgAdmin/index.vue'),
        meta: { title: '客户管理', icon: 'User' }
      },
      {
        path: 'customer-foreign',
        name: 'OrgCustomerForeign',
        component: () => import('@/views/org/orgAdmin/foreign.vue'),
        meta: { title: '客户管理', icon: 'User' }
      },
      {
        path: 'customer-data',
        name: 'OrgCustomerData',
        component: () => import('@/views/org/customerData/index.vue'),
        meta: { title: '客户数据查询', icon: 'Document' }
      }
    ]
  }
]